import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionLCTC} from "../types/types";
import {HttpLCTC} from "../api/httpLCTC";

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionLCTC: (idOperacion: number) => UseOperacionResult<OperacionLCTC> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionLCTC>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpLCTC.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return {status, operacion}
}
